import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'rcp-buttons-select-group',
  template: `
    <div class="rcp-buttons-select-group">
      <ng-content></ng-content>
    </div>
  `,
  styleUrls: ['./buttons-select-group.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [FontAwesomeModule],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ButtonsSelectGroupComponent {}
